import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "width", "title"];
import React from 'react';
import Svg from '../Svg';

var Eye = function Eye(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#2D2D2D' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '2.2rem' : _ref$width,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Eye icon' : _ref$title,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Svg, _extends({
    title: title,
    width: width,
    viewBox: "0 0 20 12",
    fill: "none"
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M9.65601 1C6.06328 1 2.17116 4.48804 0.674194 6.15138C2.17116 7.81473 6.08246 11 9.67519 11C13.2679 11 17.1772 7.81473 18.6742 6.15138C17.1772 4.48804 13.2487 1 9.65601 1Z",
    stroke: color,
    strokeWidth: "0.921212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2136 6C14.2136 8.51284 12.2712 10.5394 9.67419 10.5394C8.40537 10.5394 7.27158 9.90453 6.44359 8.99373C5.60998 8.07677 5.1348 6.93285 5.1348 6C5.1348 5.06715 5.60998 3.92323 6.44359 3.00627C7.27158 2.09547 8.40537 1.46061 9.67419 1.46061C10.943 1.46061 12.0768 2.09547 12.9048 3.00627C13.7384 3.92323 14.2136 5.06715 14.2136 6Z",
    stroke: color,
    strokeWidth: "0.921212"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "9.67419",
    cy: "6",
    r: "1",
    fill: color
  }));
};

export default Eye;